import styled from "styled-components";
import { TextCTAProps } from "./TextCTA.types";
import FONTS, { FontsType } from "../../constants/fonts";
import FontSize from "../../constants/fontSize";
export const StyledTextCTA = styled.button<Partial<TextCTAProps>>`
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    outline: inherit;

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    color: ${({ color }) => color};
    font-family: ${({ weight }) =>
        weight && FONTS[weight.toUpperCase() as FontsType]};
    display: inline-flex;
    align-items: center;
    gap: 2px;
    line-height: 1.5;
    font-size: ${({ size }) => (size ? `${FontSize[size]}rem` : "inherit")};
    text-decoration: ${({ underline }) => underline && "underline"};
    text-underline-offset: 2px;
`;
